// Module
var code = `<div id="newContextMenu" class="new-context-menu-container"></div>
<investingMenu />
<investingLoginScreen
    visible="{{.login}}"
    on-loginBtnEventClick="loginEvent"
    onDisconnectHandler="{{.onDisconnectHandler}}"
    loginLogoSrc="{{.loginLogoSource}}"
    logo_login_style="logo_login_trading_platform"
    name="loginScreen"
/>
<div id="tooltipContainer">
    <div class="ractive-tooltip ractive-tooltip-upper" style="display: none"></div>
</div>
<div id="tv_chart_container"></div>
`;
// Exports
export default code;